import { render, staticRenderFns } from "./inventory-list.vue?vue&type=template&id=880895e6&scoped=true&"
import script from "./inventory-list.vue?vue&type=script&lang=js&"
export * from "./inventory-list.vue?vue&type=script&lang=js&"
import style0 from "./inventory-list.vue?vue&type=style&index=0&id=880895e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880895e6",
  null
  
)

export default component.exports